// components/group/feed/feedApi.js
import api from '../../../lib/api';

/**
 * Group (non-admin) feed API helpers
 *
 * Course routes:
 *  - backend/routes/groupRoute/feed/course.routes.js
 *
 * Payments:
 *  - backend/routes/paymentRoute/paymentCheckoutRoutes.js
 */
export const groupFeedApi = {
  listFeed: (groupId, { limit = 20 } = {}) =>
    api.get(`/groups/${groupId}/feed`, { params: { limit } }).then((r) => r.data),

  // Course endpoints (read)
  getCourseBuilder: (groupId, courseId) =>
    api.get(`/groups/${groupId}/feed/courses/${courseId}/builder`).then((r) => r.data),

  getCourseAccess: (groupId, courseId) =>
    api.get(`/groups/${groupId}/feed/courses/${courseId}/access`).then((r) => r.data),

  /**
   * Start a Stripe Checkout session for a paid course.
   * Backend: POST `${API_BASE_PATH}/checkout/course`
   * Body: { groupId, courseId }
   * Response: { url }
   */
  startCourseCheckout: async (groupId, courseId) => {
    const resp = await api.post(`/checkout/course`, { groupId, courseId });
    return resp?.data?.url || null;
  },
  voteOnPoll: (groupId, feedItemId, payload) =>
  api.post(`/groups/${groupId}/feed/${feedItemId}/poll/vote`, payload).then(r => r.data),
};
